import { OpenClosePassengerDropdownAction } from "../../../../Actions/UIActions/Search/OpenClosePassengerDropdownAction";
import { PassengerSelectionAction } from "../../../../Actions/UIActions/Search/PassengerSelectionAction";
import { ExecutionStatus } from "../../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../../core/events/EventBus";
import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";
import { evtTree } from "../../../../Orchestrator/ConstantTree";
import { SelectPassengerType } from "../../../../Orchestrator/Types/Index";
import { SearchContext } from "../Context/SearchContext";

class SelectPassengerTypeStep extends StepFlow {
    get stepName() { return "SelectSearchPassengerType_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on<SelectPassengerType, void>({
                eventName: evtTree.SearchBar.SelectPassenger.IncDecClick,
                handler: async (payload) => {
                    const context = this.getCtx<SearchContext>("searchContext")!
                    context.selectPassengerType = payload.data!
                    const action = new PassengerSelectionAction();
                    action.setParams({ ...context.selectPassengerType });
                    await action.execute();
                    if (action.status.executionStatus === ExecutionStatus.SUCCESS && action.result) {
                        context.searchStateAtom = { ...action.result };
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<boolean, void>({
                eventName: evtTree.SearchBar.SelectPassenger.OpenPopUp,
                handler: async (payload) => {
                    const context = this.getCtx<SearchContext>("searchContext")!
                    context.isPassengerDropdownOpen = payload.data || false
                    const dropdownAction = new OpenClosePassengerDropdownAction();
                    dropdownAction.setParams(context.isPassengerDropdownOpen);
                    await dropdownAction.execute();
                    context.stepRoute = "SearchStartupInit_Step"
                    this.next()
                }
            })
        )
    }

    async onExecute(): Promise<void> {

    }
}
export const SelectSearchPassengerTypeStepDeclaration = new StepDefinition({
    stepName: "SelectSearchPassengerType_Step",
    stepClass: SelectPassengerTypeStep
});